import axios from 'axios'
import { dl } from '../../../src/js/core/app'

export const initNewsletter = () => {
  const newsletter = document.querySelector('.js-newsletter')
  if (!newsletter) { return false }

  new Newsletter(newsletter)
}

class Newsletter {
  constructor (newsletter) {
    this.newsletter = newsletter
    this.thankyoumesage = document.querySelector('.js-newsletter-thankyou')
    this.init()
  }

  send () {
    const button = this.newsletter.querySelector('button')
    button.querySelector('.js-text').innerHTML = this.newsletter.getAttribute('data-sending')
    this.newsletter.style.pointerEvents = 'none'

    const email = this.newsletter.querySelector('input[type="email"]').value
    const firstName = this.newsletter.querySelector('input[name="first_name"]').value
    const lastName = this.newsletter.querySelector('input[name="last_name"]').value
    const tag = this.newsletter.querySelector('input[name="tag"]').value
    const listId = this.newsletter.querySelector('input[name="list_id"]').value
    const formData = new URLSearchParams()
    formData.append('action', 'llActiveCampaignAddUser')
    formData.append('email', email)
    formData.append('first_name', firstName)
    formData.append('last_name', lastName)
    formData.append('list_id', listId)
    formData.append('tag', tag)

    axios
      .post('/wp-admin/admin-ajax.php', formData)
      .then(response => {
        button.querySelector('.js-text').innerHTML = this.newsletter.getAttribute('data-sent')
        this.thankyoumesage.classList.remove('hidden')
        this.newsletter.classList.add('hidden')
        dl.newsletter()

        setTimeout(() => {
          button.querySelector('.js-text').innerHTML = this.newsletter.getAttribute('data-original')
          this.newsletter.style.pointerEvents = 'all'
          this.newsletter.reset()
          this.thankyoumesage.classList.add('hidden')
          this.newsletter.classList.remove('hidden')
        }, 5000)
      })
      .catch(error => {
        console.error(error)
      })
  }

  init () {
    this.newsletter.addEventListener('submit', e => {
      e.preventDefault()
      this.send()
    })
  }
}
